import { AxiosRequestConfig } from 'axios';
import { v3Get } from './axios.instance.V3';
import { ApiResponse } from './types';
import routes from '@/config/routes';

const fetchClientConfigurations = (config?: AxiosRequestConfig): ApiResponse =>
  v3Get(`${routes.backendUrl.apiConfiguration.apiSsoConfigurationEndpoint}`, config);

export const apiConfigurations = {
  fetchClientConfigurations,
};
